import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SsoService } from 'src/app/shared/services/sso.service';

@Component({
  selector: 'fgb-sso-callback',
  templateUrl: './sso-callback.component.html',
  styleUrls: ['./sso-callback.component.scss'],
})
export class SsoCallbackComponent implements OnInit {
  constructor(
    private ssoService: SsoService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const { email, userId, accountnumber } = this.route.snapshot.queryParams;
    window.location.href = this.ssoService.getThirdPartyCallbackUrl(email, userId, accountnumber);
  }
}
